import React from 'react';
import PropTypes from 'prop-types';

import { bookingShape } from 'constants/propTypes';
import Spinner from 'admin-components/components/Spinner';
import Payments from 'components/ui/Payments';
import { Row, Page, Column } from 'components/shared/Layout';
import RevertExchangeButton from 'components/shared/RevertExchangeButton';
import { hasHotel } from 'utils/booking';

const PaymentExchange = ({ loading, booking, refetchBooking, currency, cancelPayments }) => {
  if (loading) {
    return (
      <Row span={16} height="100vh">
        <Column justifyContent="center" alignItems="center">
          <Spinner />
        </Column>
      </Row>
    );
  }

  return (
    <Page>
      <Row start={2} span={14}>
        <Column>
          <RevertExchangeButton
            reference={booking.reference}
            currency={currency}
            payments={booking.payments}
            hasHotel={booking.isPackage || hasHotel(booking)}
            status={booking.status}
            changeExpiryTimestamp={booking.changeExpiryTimestamp}
          />
        </Column>
      </Row>
      <Row start={2} span={14}>
        <Payments
          reference={booking.reference}
          customer={booking.customer}
          currency={currency}
          status={booking.status}
          totalPriceToBePaid={booking.totalPriceToBePaid}
          payments={booking.payments}
          amountDue={booking.amountDue}
          depositAmount={booking.onHold.depositAmount}
          cancelPayments={cancelPayments}
          isPackage={booking.isPackage}
          hasHotel={hasHotel(booking)}
          refetchBooking={refetchBooking}
          outbound={booking.outbound}
          inbound={booking.inbound}
          passengers={booking.passengers}
          isExchange
          additionalDetails={booking.additionalDetails || []}
          isLoyalty={booking.isLoyalty}
        />
      </Row>
    </Page>
  );
};

PaymentExchange.propTypes = {
  loading: PropTypes.bool,
  booking: bookingShape,
  refetchBooking: PropTypes.func,
  currency: PropTypes.string,
  cancelPayments: PropTypes.func.isRequired
};

export default PaymentExchange;
